<template>
    <div>
        <div class="login-header-n">
        </div>
        <div class="paper form login-card">
          <div>
              <a :href="this.view.routes.rota_office_index">
              <img class="img-responsive center-block" :src="this.view.wl_logo">
            </a>
          </div>
            <h3 class="llt">
                {{view.translations.label_login_title_v5}}
            </h3>
            <form
                method="post"
                id="formLogin"
                ref="formLogin"
                :action="formLoginAction"
                @submit="loginSubmit"
            >
                    <!-- v-model="input_token" -->
                <div :class="['text-left', input_email == '' ? '' : ($v.input_email.$invalid ? 'has-error' : 'has-success') ]">
                    <label for="email" class="form-label">
                        {{view.translations.email}} *
                    </label>
                    <input
                        type="email"
                        name="email"
                        class="email"
                        id="email"
                        required
                        v-model="input_email"
                        @change="onChange('input_email_v', input_email)"
                    >
                </div>
                <div :class="['text-left',  input_password == '' ? '' : ($v.input_password.$invalid ? 'has-error' : 'has-success') ]">
                    <label for="senha" class="form-label" id="labelSenha">
                        {{labelSenha}} *
                    </label>
                    <input
                        type="password"
                        name="senha"
                        class="senha"
                        id="senha"
                        required
                        v-model="input_password"
                        @change="onChange('input_password_v', input_password)"
                    >
                </div>
              <div class="text-right va-forgot-password">
                <div class="checkbox">
                  <input
                    type="checkbox"
                    name="virtual_assistant"
                    id="virtual_assistant"
                    v-show="false"
                    v-model="checkbox_va"
                    :value="checkbox_va ? 1 : 0"
                  >
                </div>
                <div class="separator"></div>
                <div class="forgot-password">
                  {{view.translations.label_lembrar_senha_v5}}
                  <a
                    class=""
                    :href="view.routes['forgot-password']"
                  >
                    {{view.translations.label_password_v5}}
                  </a>
                </div>
              </div>
                <div class="btn-ajust">
                    <button
                        id="submit-btn"
                        name="submit_btn"
                        class="btn-success display-block"
                        :disabled="$v.input_email.$invalid || $v.input_password.$invalid"
                    >
                        {{view.translations.button_login}}
                    </button>
                </div>
            </form>
        <div class="login-footer" v-if="!view.hide_dont_have_account">
            <div  class="dont-have-account">
                {{view.translations.label_dont_have_an_v5}} <a
                    class=""
                    :href="custom_register_route"
                >
                    {{view.translations.label_account_v5}}
                </a>
            </div>
        </div>
        </div>
     </div>
</template>

<script>
    import { SpringSpinner } from 'epic-spinners'
    const { required, email } = require('vuelidate/lib/validators')
    export default {
        name: 'lv5-form',
        props: ['view'],
        components: {
            'spring-spinner': SpringSpinner
        },
        validations: {
            input_email: {
                required,
                email
            },
            input_email_v: {
                required,
                email
            },
            input_password: {
                required
            },
            input_password_v: {
                required
            }
        },
        data: function(){
            return {
                loadingGoogleApi: false,
                disableGoogleBtn: true,

                loadingFacebookApi: false,
                disableFacebookBtn: true,

                office_btn: '',

                input_login_type: '',
                input_token: '',
                input_email: '',
                input_email_v: '',
                input_password: '',
                input_password_v: '',
                checkbox_va: false,

                custom_register_route: "",
            }
        },
        methods: {
            loginSubmit() {
                this.$emit('login-submit');
            },
            removeParam(key, sourceURL) {
                let rtn = sourceURL.split("?")[0];
                let param = '';
                let params_arr = [];
                let queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";

                if (queryString !== "") {
                    params_arr = queryString.split("&");
                    for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                        param = params_arr[i].split("=")[0];
                        if (param === key) {
                            params_arr.splice(i, 1); // remove param
                        }
                    }
                    rtn = rtn + "?" + params_arr.join("&");
                }
                return rtn;
            },
            toggleOfficeButton(){
                console.log('toggle')
                this.office_btn = this.office_btn === 'normal' ? 'business' : 'normal';

                if(this.office_btn == 'normal') {
					var alteredURL = this.removeParam('redir', window.location.href );
					window.history.pushState({ path: alteredURL }, '', alteredURL);
				}
				if(this.office_btn == 'business') {
					var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?app=ba5&redir=%2Fbr%2Foffice%2Ffranchise-system';
					window.history.pushState({ path: newurl }, '', newurl);
				}

                this.$emit('toggle-office-button')
            },

            onChange(key, value) {
                this[key] = value;
                this.$v[key].$touch();
            },
            setAidHashToCreatePage(){
                this.custom_register_route = this.view.routes['dont-have-account'];
                let hash = location.hash;
                hash =  hash.substring(1);
                hash = hash.split('&');

                for(let i =0; i < hash.length; i++){
                    if(hash[i].indexOf('aid') === 0){
                        this.custom_register_route = this.view.routes['dont-have-account'] + '/#' + hash[i];
                    }
                }
            },
        },
        created() {
            this.office_btn = this.view.data.redirDefined ? 'business' : 'normal'
            this.setAidHashToCreatePage();
        },
        mounted(){
            let vm = this;
            $(window).on('load', function(){
                if(vm.view.data.back_toastr_message !== false){
                    vm.$toast[vm.view.data.back_toastr_message_type](vm.view.data.back_toastr_message.replace(/(<([^>]+)>)/ig," "))
                }
            })
        },
        computed: {
            labelSenha() {
                return this.checkbox_va ? this.view.translations.label_access_key : this.view.translations.Senha;
            },
            formLoginAction() {
                return this.checkbox_va ? this.view.routes['rota-office-login-va'] : '';
            },
        },
        watch: {
            '$v.$invalid': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.clear();
                    }
                },
                deep: true
            },
            '$v.input_email_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.view.translations.email} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
            '$v.input_email_v.email': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(this.view.translations.label_invalid_email_v5) );
                    }
                },
                deep: true
            },
            '$v.input_password_v.required': {
                handler: function(newVal, oldVal) {
                    if( !newVal ) {
                        this.$toast.error( window.getInnerComponent(`${this.labelSenha} ${this.view.translations.label_required_v5}`) );
                    }
                },
                deep: true
            },
        }
    }
</script>

<style>
  .btn-success {
  box-shadow: 0 0.48rem 1.52rem -0.32rem #0a79e9 !important;
  }
</style>

<style scoped lang="scss">

  *{
      font-family: "Manrope" !important;
  }

  .llt{
    font-size: 1.97rem !important;
    line-height: 32.78px;
    font-weight: 800 !important;
    color: #0053C2 !important;
    letter-spacing: 0.0168em !important;
    font-feature-settings: 'tnum' on, 'lnum' on;
    margin-bottom: 0.9rem;
  }
  /* .text-left{
    margin-left: 3.18rem !important;
    margin-right: 3.18rem !important;
  }
 */
  .login-card {
    background: #F9FBFB !important;

  }
  .form-label{
      color:#097EF6 !important;
      //font-size: 0.87rem !important;
  }
  #formLogin{
    margin-left: 3.18rem !important;
    margin-right: 3.18rem !important;
  }
  /* .display-block{
    display: block !important;
    min-width: 100%;
  } */
 /*  .btn-ajust{
    margin-left: 3.18rem !important;
    margin-right: 3.18rem !important;
    min-width:100%
    } */

  .btn-success{
    font-size: 1.5rem !important;
    background-color: #097EF6 !important;
    font-family: "Roboto" !important;
  }
  .btn-success:hover {
  background-color: #097EF6 !important;
  box-shadow: 0 0.48rem 1.52rem -0.32rem #0a79e9 !important;
  }
  .builderall-css .login-card form .va-forgot-password .forgot-password {
    font-size: 1.2rem !important;
    color: #ACACAC !important;
  }
  .img-responsive.center-block {
    width: 18rem !important;
    margin-top: 6.25rem !important;
    margin-bottom: 2rem !important;
  }
  .dont-have-account {
    font-size: 1.2rem !important;
    margin-bottom: 6.25rem !important;
    text-align: center;
    color: #ACACAC !important;
  }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/wl-auth/forms/login.vue